import React, { Fragment, useState } from "react";
import Card from "../../../components/card/Card";
import Dropdown from "../../../components/dropdown/Dropdown";
import { Modal } from "../../../components/modal/Modal";
import RegisterModal from "../../../sections/register/RegisterModal";
import { DayPairKey, cardData } from "../../../utils/DataUtils";
import { filterFutureDates } from "../../../utils/DataFormatter";

const DatesModal = ({
  type,
  showDatesModal,
  cardDataValues,
  handleDropdown,
  onToggleDatesModal,
}: {
  showDatesModal: boolean;
  cardDataValues: cardData[];
  type: "plus" | "vku" | null;
  onToggleDatesModal: () => void;
  handleDropdown: (selectedDay: Set<string>[]) => void;
}) => {
  const [selectedCard, setSelectedCard] = useState();
  const recentData = filterFutureDates(cardDataValues);
  const [showRegisterModal, setShowRegisterModal] = useState(false);

  const toggleShowRegisterModal = () =>
    setShowRegisterModal(!showRegisterModal);

  const handleCardClick = (data: any) => {
    setSelectedCard(data);
    toggleShowRegisterModal();
  };
  return (
    <Fragment>
      <RegisterModal
        type={type}
        showModal={showRegisterModal}
        onToggleModal={toggleShowRegisterModal}
        cardSelectedValues={selectedCard}
      />
      <Modal
        modalNumber={5}
        showOverflow={false}
        isOpen={showDatesModal}
        onToggleModal={onToggleDatesModal}
        headerText="Buchen Sie einen Kurstermin"
      >
        <div className="flex flex-col h-full">
          <div className="space-x-2 h-fit mb-5 mt-2 max-md:text-center">
            <label className="w-full font-semibold pl-5 mt-2 mr-4 font-title text-dark-blue text-xl">
              Waehlen Sie einen Tag
            </label>
            <Dropdown handleDropdownData={handleDropdown} data={recentData} />
          </div>
          <div className="space-y-4 overflow-y-auto flex flex-col max-md:max-h-[calc(90vh-210px)] max-sm:max-h-[calc(90vh-310px)] md:max-h-[calc(90vh-170px)]">
            {recentData?.map((course, index) => {
              return (
                <Card
                  key={index}
                  data={course}
                  courseType={type}
                  showModal={handleCardClick}
                />
              );
            })}
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};

export default DatesModal;
